import grayHeart from 'public/static/images/favorites/gray-heart.svg';
import heart from 'public/static/images/favorites/heart.svg';
import classNames from 'classnames';
import { DetailedHTMLProps, ButtonHTMLAttributes } from 'react';

interface Props
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  onClick(): void;
  active: boolean;
  className?: string;
}

export default function Heart({ active, onClick, className, ...props }: Props): JSX.Element {
  return (
    <>
      <button
        className={classNames('heart', className)}
        data-testid="heart"
        onClick={(): void => onClick()}
        {...props}
      />
      <style jsx>{`
        .heart {
          cursor: pointer;
          height: 28px;
          width: 30px;
          border: none;
          background-color: transparent;
          background-image: url(${active ? heart : grayHeart});
          background-repeat: no-repeat;
        }

        .heart:focus {
          outline: 0;
        }
      `}</style>
    </>
  );
}
